const config = {
  development: {
    api_url: 'http://localhost:3000',
    modfile_url: 'http://localhost:3002'
  },
  testing: {
    api_url: 'https://api.testing.quickin.net',
    modfile_url: 'https://modfile.testing.quickin.net'
  },
  staging: {
    api_url: 'https://api.staging.quickin.net',
    modfile_url: 'https://modfile.staging.quickin.net'
  },
  production: {
    api_url: 'https://api.quickin.io',
    modfile_url: 'https://modfile.quickin.io'
  }
}

console.log(process.env.NODE_ENV)
export default config[process.env.NODE_ENV || 'development']
